<template>
  <v-app>
    <v-app-bar
      app
      color="rgba(0,0,0,0.9)"
      dark
    >
    <router-link to="/">
      <div class="d-flex align-center">
        <v-img
          alt="Csigavér Webfejlesztés"
          class="shrink mr-2"
          contain
          src="https://szoftver-fejlesztes.csigaver.hu/wp-content/uploads/2021/03/snail.png"
          transition="scale-transition"
          width="60"
        />

      </div>
    </router-link>

      <v-spacer></v-spacer>

      <v-toolbar-title><b>Csigavér Webfejlesztés</b></v-toolbar-title>

      <v-spacer></v-spacer>

      <div class="hidden-sm-and-down">
        <v-btn text to="/">Kezdőlap<v-icon right>home</v-icon></v-btn>
        <v-btn text to="/demo">Demo Alkalmazás<v-icon right>dashboard</v-icon></v-btn>
        <v-btn text to="/kapcsolat">Kapcsolat<v-icon right>call</v-icon></v-btn>
      </div>

      <div class="hidden-md-and-up">
        <v-btn @click.stop="drawer = !drawer">
          <v-icon>menu</v-icon>
        </v-btn>
      </div>

    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      temporary
      right
      app
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Főmenü</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>

        <v-list-item
          link
          to="/"
        >
          <v-list-item-icon>
            <v-icon>home</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Kezdőlap</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          link
          to="/demo"
        >
          <v-list-item-icon>
            <v-icon>dashboard</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Demo Alkalmazás</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          link
          to="/kapcsolat"
        >
          <v-list-item-icon>
            <v-icon>call</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Kapcsolat</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>

    <v-main>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </v-main>

  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
  },

  data: () => ({
      drawer: null,
  }),
  methods: {

  }
};
</script>

<style>

</style>
